var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ModalLikes',{attrs:{"idPost":_vm.news._id,"nameEvent":"likeNews","endpoint":"/news/likes"},on:{"close":_vm.newsClose}})
}
var staticRenderFns = []

export { render, staticRenderFns }